<template>
  	<div id="app" class="fillcontain">
		    <router-view></router-view>
    </div>
</template>

<script>
import $ from 'jquery'

export default {
  created () {
    this.checkBrowser()
    try {
        document.body.removeChild(document.getElementById('appLoading'))
        setTimeout(function() {
          document.getElementById('app').style.display = 'block';
        }, 500)
      } catch (e) {

      }
  },
  methods: {
  	checkBrowser(){
			if(document.all){ 
			    this.$alert('请将浏览器升级到IE9以上', '', {
		            	confirmButtonText: '确定',
		            	type:'info',
		            	customClass:'alert-box'
		            })
			}

	}
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue